import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';

// services
import { HelpService } from '@open-portal-app/help/services/help.service';

// constants
import { HELP_CONSTANTS } from '@open-portal-app/help/constants/help.constants';


// Pipes
import { AddressPipe } from '@open-portal-app/core/pipes/address.pipe';

@Component({
  selector: 'app-help-reference-list',
  templateUrl: './help-reference-list.component.html',
  styleUrls: ['./help-reference-list.component.scss']
})
export class HelpReferenceListComponent implements OnInit {
  @Input() policies?: any;
  @Input() claims?: any;
  helpFlow: any;
  helpReferenceAnswer!: { slug: string, class?: string };
  subject!: string;
  subjectSource: any;
  customerIntent!: string;
  badgeStatus = HELP_CONSTANTS.policyBadgeStatus as any;

  constructor(
    private helpService: HelpService,
    private addressPipe: AddressPipe
  ) { }

  ngOnInit(): void {
    // Fetch entire help flow state info
    this.helpFlow = this.helpService.getHelpflow();
    const customerIntentStep = this.helpFlow.steps.find((step: { slug: string; }) => step.slug === 'customer-intent');
    this.customerIntent = customerIntentStep ? customerIntentStep.answer : null;
    // Checking of answer was previously selected
    let helpReference = this.helpFlow.steps.find((step: { slug: string; }) => {
      return step.slug === 'reference-list';
    });
    this.helpReferenceAnswer = helpReference.answer;

    if (
      this.helpReferenceAnswer &&
      this.helpService.isPrePopulated &&
      this.customerIntent !== 'existing-claim'
    ) {
      this.helpService.isPrePopulated = false;
      this.helpService.returnUrl = undefined;
      this.goToNextStep();
    } else {
      this.setReferenceListSource();
      this.setReferenceSubject();
    }
  }

  setReferenceSubject() {
    const headings = {
      policy: 'Select the policy you need help with',
      claim: 'Select the claim you need help with',
      odo: 'Select the policy you want to update'
    } as any;
    // Get help subject to display on the Heading
    let helpSubject = this.helpFlow.steps.find((step: { slug: string; }) => step.slug === 'subject');

    if (helpSubject?.answer === 'payment' || helpSubject?.answer === 'other') {
      this.subject = headings.policy;
    } else if (helpSubject?.answer === 'claim') {
      this.subject = this.customerIntent === 'start-claim' ? headings.policy : headings.claim;
    } else if (helpSubject?.answer === 'odo') {
      this.subject = headings.odo;
    } else {
      this.subject = headings[helpSubject.answer];
    }
  }

  setReferenceListSource() {
    const helpSubject = this.helpFlow.steps.find((step: { slug: string; }) => step.slug === 'subject');
    let policies = [];
    let claims = [];

    if (helpSubject?.answer === 'odo') {
      policies = this.helpService.odoRequiredPolicies;
      this.subjectSource = policies;
    } else if (this.customerIntent === 'existing-claim') {
      claims = this.claims.map((claim: any) => ({
        ...claim,
        checked: claim.key === this.helpReferenceAnswer
      }));
    } else {
      policies = this.policies.map((policy: any) => ({
        ...policy,
        checked: policy.key === this.helpReferenceAnswer && this.helpReferenceAnswer.slug
      }));
    }

    if (this.customerIntent === 'retry-payment') {
      policies = policies.filter((policy: any) => policy.overdueInvoices && policy.overdueInvoices.count > 0);
    }

    if (this.customerIntent === 'existing-claim') {
      this.subjectSource = claims;
    } else if (helpSubject?.answer !== 'odo') {
      this.subjectSource = policies.sort((a: any, b: any) => {
        return moment(a.created) < moment(b.created) ? 1 : -1;
      });
    }
  }

  getCoveredEntity(productClass: string, policyData: any) {
    let entity = '';

    if (productClass === 'car') {
      entity = policyData.helpflowCarDisplayName;
    } else if (productClass === 'home') {
      entity = !policyData.isRaptorial? (this.addressPipe.transform(policyData.address)) : policyData.address;
    }

    return entity;
  }

  selectedItem(event: any): void {
    this.goToNextStep(event && event.value);
  }

  goToNextStep(selectedRef?: any) {
    this.helpService.next((selectedRef && selectedRef.value) || this.helpReferenceAnswer, this.customerIntent);
  }
}
